import { namespace } from 'vuex-class';
import { IGoogleDocsState } from '@/google-docs/store/google-docs.types';

export const GoogleDocs = namespace('googleDocs');

export const state: IGoogleDocsState = {
  importing: false,
  imported: false,
  documents: [],
};

export enum EGoogleDocsAction {
  LoadDocuments = 'loadDocuments',
  LoadDocumentsSuccess = 'loadDocumentsSuccess',
  LoadDocumentsFailed = 'loadDocumentsFailed',
  Reset = 'resetState',
}

export enum EGoogleDocsMutation {
  SetImporting = 'setImporting',
  SetImported = 'setImported',
  SetDocuments = 'setDocuments',
  SetState = 'setState',
}
